import { http } from 'services';

export function getSettingsPresets(type, query, cbSuccess, cbError) {
  http.get(
    `settings/presets/${type}`,
     query,
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function getSettingsPresetDetails(type, id, cbSuccess, cbError) {
  http.get(
    `settings/presets/${type}/${id}`,
    {},
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}


export function saveSettingsPreset(type, data, cbSuccess, cbError) {
  http.post(
    `settings/presets/${type}`,
    data,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function editSettingsPreset(type, id, data, cbSuccess, cbError) {
  http.post(
    `settings/presets/${type}/${id}`,
    data,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function deleteSettingsPreset(type, id, cbSuccess, cbError) {
  http.delete(
    `settings/presets/${type}/${id}`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// GET .../settings/presets/${type}
// GET .../settings/presets/${type}/{id}
// POST .../settings/presets/${type}
// PUT|PATCH .../settings/presets/${type}/{id}
// DELETE .../settings/presets/${type}/{id}



// WEBPACK FOOTER //
// ./src/api/api-settings/api-settings-presets.js